import type { TrackingProps, PageDataProps } from "./types";

// Get Snowplow config from page data props
export const getSnowplowConfig = (
  pageData: PageDataProps,
): TrackingProps | undefined =>
  pageData.scripts?.find(({ metadata }) => metadata.name === "snowplow")
    ?.props as TrackingProps;
